import { computed } from 'vue'
import type { ComputedRef, Ref } from 'vue'
import type { ChatMessageCp } from '@/types/chatCp'

const WINDOW_SECONDS = 24 * 60 * 60

/**
 * Janela de 24h de mensagens do WhatsApp — irmão WootDash-nativo de useMessageWindow.ts
 * (que continua servindo FocoView.vue/MobileView.vue sem mudança). "Incoming" aqui é
 * senderType === 'Contact' (mensagem de Bot/Agent/System não reabre a janela).
 */
export function useMessageWindowCp(
  messages: Ref<ChatMessageCp[]> | ComputedRef<ChatMessageCp[]>,
  nowSec: Ref<number> | ComputedRef<number>,
) {
  const lastIncomingAt = computed(() => {
    const msgs = messages.value
    for (let i = msgs.length - 1; i >= 0; i--) {
      if (msgs[i].senderType === 'Contact') return Math.floor(new Date(msgs[i].createdAt).getTime() / 1000)
    }
    return null
  })

  const isWindowClosed = computed(() => {
    const ts = lastIncomingAt.value
    return ts != null && nowSec.value - ts >= WINDOW_SECONDS
  })

  return { isWindowClosed }
}
